import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=a6bc1678&scoped=true&"
import script from "./Vendor.vue?vue&type=script&lang=ts&"
export * from "./Vendor.vue?vue&type=script&lang=ts&"
import style0 from "./Vendor.vue?vue&type=style&index=0&id=a6bc1678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bc1678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
